import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { cancelLibraryAppointmentByToken } from '../../api/libraryAppointmentService';
import { FaExclamationTriangle, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

const AppointmentCancellation = () => {
    const [status, setStatus] = useState('idle'); // idle, processing, success, error
    const [message, setMessage] = useState('');
    const location = useLocation();
    const navigate = useNavigate();

    // Extract token from query string
    const getQuery = () => new URLSearchParams(location.search);
    const token = getQuery().get('token');

    useEffect(() => {
        if (!token) {
            setStatus('error');
            setMessage('Geçersiz veya eksik iptal bağlantısı.');
        }
    }, [token]);

    const handleConfirm = async () => {
        setStatus('processing');
        try {
            const result = await cancelLibraryAppointmentByToken(token);
            if (result.isSuccess) {
                setStatus('success');
                setMessage(result.resultMessage || 'Randevunuz başarıyla iptal edildi.');
            } else {
                setStatus('error');
                setMessage(result.resultMessage || 'İptal işlemi başarısız oldu.');
            }
        } catch (err) {
            setStatus('error');
            setMessage('Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.');
        }
    };

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <div className="container" style={{ padding: '60px 20px', minHeight: '60vh', display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }}>
            <div style={{
                maxWidth: '500px',
                width: '100%',
                backgroundColor: '#fff',
                borderRadius: '12px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                padding: '30px',
                textAlign: 'center'
            }}>

                {/* IDLE STATE */}
                {status === 'idle' && (
                    <>
                        <div style={{ fontSize: '48px', color: '#ED802C', marginBottom: '20px' }}>
                            <FaExclamationTriangle style={{ display: 'inline-block' }} />
                        </div>
                        <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#1a1a1a', marginBottom: '15px' }}>
                            Randevu İptali
                        </h2>
                        <p style={{ fontSize: '16px', color: '#555', lineHeight: '1.6', marginBottom: '30px' }}>
                            Kütüphane randevunuzu iptal etmek üzeresiniz. Bu işlem geri alınamaz.
                            <br />
                            <strong>Onaylıyor musunuz?</strong>
                        </p>
                        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
                            <button
                                onClick={handleGoHome}
                                style={{
                                    padding: '12px 24px',
                                    borderRadius: '8px',
                                    border: '1px solid #ddd',
                                    backgroundColor: '#f8f9fa',
                                    color: '#333',
                                    fontSize: '15px',
                                    cursor: 'pointer',
                                    fontWeight: '600'
                                }}>
                                Vazgeç
                            </button>
                            <button
                                onClick={handleConfirm}
                                style={{
                                    padding: '12px 24px',
                                    borderRadius: '8px',
                                    border: 'none',
                                    backgroundColor: '#d32f2f',
                                    color: '#fff',
                                    fontSize: '15px',
                                    cursor: 'pointer',
                                    fontWeight: '600',
                                    boxShadow: '0 2px 8px rgba(211, 47, 47, 0.3)'
                                }}>
                                Evet, İptal Et
                            </button>
                        </div>
                    </>
                )}

                {/* PROCESSING STATE */}
                {status === 'processing' && (
                    <div style={{ padding: '40px 0' }}>
                        <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem', border: '4px solid #f3f3f3', borderTop: '4px solid #237CB2', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto' }}></div>
                        <p style={{ marginTop: '20px', color: '#555' }}>İşleminiz yapılıyor...</p>
                        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                    </div>
                )}

                {/* SUCCESS STATE */}
                {status === 'success' && (
                    <>
                        <div style={{ fontSize: '48px', color: '#2e7d32', marginBottom: '20px' }}>
                            <FaCheckCircle style={{ display: 'inline-block' }} />
                        </div>
                        <h2 style={{ fontSize: '22px', fontWeight: 'bold', color: '#1a1a1a', marginBottom: '15px' }}>
                            İşlem Başarılı
                        </h2>
                        <p style={{ fontSize: '16px', color: '#555', marginBottom: '30px' }}>
                            {message}
                        </p>
                        <button
                            onClick={handleGoHome}
                            style={{
                                padding: '12px 30px',
                                borderRadius: '8px',
                                border: 'none',
                                backgroundColor: '#237CB2',
                                color: '#fff',
                                fontSize: '15px',
                                cursor: 'pointer',
                                fontWeight: '600'
                            }}>
                            Ana Sayfaya Dön
                        </button>
                    </>
                )}

                {/* ERROR STATE */}
                {status === 'error' && (
                    <>
                        <div style={{ fontSize: '48px', color: '#d32f2f', marginBottom: '20px' }}>
                            <FaTimesCircle style={{ display: 'inline-block' }} />
                        </div>
                        <h2 style={{ fontSize: '22px', fontWeight: 'bold', color: '#1a1a1a', marginBottom: '15px' }}>
                            İşlem Başarısız
                        </h2>
                        <p style={{ fontSize: '16px', color: '#555', marginBottom: '30px' }}>
                            {message}
                        </p>
                        <button
                            onClick={handleGoHome}
                            style={{
                                padding: '12px 30px',
                                borderRadius: '8px',
                                border: 'none',
                                backgroundColor: '#237CB2',
                                color: '#fff',
                                fontSize: '15px',
                                cursor: 'pointer',
                                fontWeight: '600'
                            }}>
                            Ana Sayfaya Dön
                        </button>
                    </>
                )}

            </div>
        </div>
    );
};

export default AppointmentCancellation;
